import { MergeDataset } from '../../decorators';;
import { ActivityEntityName } from '../../../../entities';
import { CompanyMergeData, EmployeeMergeData, QuoteProMergeData, AccountContactMergeData, AccountMergeData, BasicSiteMergeData } from '../data';
import { QuoteProMergeDataset } from './quote.pro.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.QuoteOpportunity,
    dependsOn: [ActivityEntityName.Opportunity]
})
export class QuoteProOpportunityMergeDataset extends QuoteProMergeDataset {
    public static get empty() {
        return {
            quote: new QuoteProMergeData(),
            quoteOwner: new EmployeeMergeData(),
            quoteContact: new AccountContactMergeData(),
            quoteAccount: new AccountMergeData(),
            quoteSite: new BasicSiteMergeData(),
            quoteCompany: new CompanyMergeData(),
            theme: null
        } as QuoteProOpportunityMergeDataset;
    }
}